export default "__VITE_ASSET__D65bt2u8__"